import { shiftBreakComplianceSchema } from "api/resources/shared";
import * as z from "zod/mini";

// The whole filter set rides in ONE namespaced URL param (`applicationParams`) because the container
// mounts under host routes whose own `page`/`ordering` would collide with these. TanStack's default
// serializer JSON-encodes the object natively; only the date fields need coercion off the ISO string.
export const applicationParamsSchema = z.object({
  ordering: z.optional(z.string()),
  pro_id: z.optional(z.number()),
  gig_id: z.optional(z.number()),
  location_name: z.optional(z.string()),
  skill_name: z.optional(z.string()),
  is_confirmed: z.optional(z.boolean()),
  is_cancelled: z.optional(z.boolean()),
  is_selected: z.optional(z.boolean()),
  is_gig_cancelled: z.optional(z.boolean()),
  unpaid_pros: z.optional(z.boolean()),
  uncharged_businesses: z.optional(z.boolean()),
  shift_break_compliance: z.optional(shiftBreakComplianceSchema),
  gig__start_time__gte: z.optional(z.coerce.date()),
  gig__start_time__lte: z.optional(z.coerce.date()),
  gig__end_time__gte: z.optional(z.coerce.date()),
  gig__end_time__lte: z.optional(z.coerce.date()),
  page: z._default(z.number(), 1),
  page_size: z._default(z.number(), 25),
});

export type ApplicationParams = z.infer<typeof applicationParamsSchema>;

export const APPLICATION_PARAMS_DEFAULT: ApplicationParams = {
  ordering: "-gig__start_time",
  page: 1,
  page_size: 25,
  is_confirmed: true,
};

export const applicationHistorySearchSchema = {
  applicationParams: z.optional(applicationParamsSchema),
};
